import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Trip } from '../../models/Trip/Trip.model';
import { AddTrips, RemoveTrips } from '../actions/trips.action';

export class TripStateModel {
  trips: Trip[];
}

@State({
  name: 'trips',
  defaults: {
    trips: [],
  },
})
export class TripState {
  @Selector()
  static getTrips(state: TripStateModel) {
    return state.trips;
  }

  @Action(AddTrips)
  add({ patchState }: StateContext<TripStateModel>, { payload }: AddTrips) {
    patchState({ trips: payload });
  }

  @Action(RemoveTrips)
  remove({ patchState }: StateContext<TripStateModel>) {
    patchState({ trips: [] });
  }
}
